/**
 * Parses a UTC timestamp of the maintenance window into epoch milliseconds.
 *
 * Die einzige Stelle, an der die Zeitstempel des Wartungsfensters geparst werden: fehlende und unlesbare
 * Werte sind hier gleichwertig, damit alle Berechnungen dieselbe `null`-Bedeutung haben.
 * @param value The UTC timestamp, `null` when the window does not disclose it.
 * @returns The epoch milliseconds or `null` when the value is missing or cannot be parsed.
 */
export function parseUtcTimestamp(value: string | null): number | null {
  if (!value) {
    return null;
  }

  const parsed = Date.parse(value);

  return Number.isNaN(parsed) ? null : parsed;
}
